export default {
  slug: "university-programs",
  code: "UNI",
  label: "University Programs",
  krakenDir: "University Programs",
  logoFamily: "jb",
};
